import { render, staticRenderFns } from "./AudioRecorder.vue?vue&type=template&id=3c2ffa1c&scoped=true"
import script from "./AudioRecorder.vue?vue&type=script&lang=js"
export * from "./AudioRecorder.vue?vue&type=script&lang=js"
import style0 from "./AudioRecorder.vue?vue&type=style&index=0&id=3c2ffa1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2ffa1c",
  null
  
)

export default component.exports